<template>
    <div class="projects-page-outer">
        <TheDebug v-if="debugWindow"></TheDebug>
        <div id="projects-page" v-bind:class="{'is-blurred': isLoading}">
            <TheModal/>
            <TheNavbar/>
            <div id="configurator-group">
                <TheStepsSidebar/>

<!--                <button style="position: absolute; bottom: 10px; left: 30px; width: 40px; height: 40px;-->
<!--                display: flex; justify-content: center; align-items: center; font-weight: bold; font-size: 20px; z-index: 100"-->
<!--                v-if="$route.name === 'designMaterials' || $route.name === 'designMaterialsSelectedGroup'"-->
<!--                v-on:click="sendDataOnError">-->
<!--                    !-->
<!--                </button>-->

                <vue-custom-scrollbar class="sidenav">
                    <router-view name="sidebar"></router-view>
                </vue-custom-scrollbar>
                <div id="workspace-group">
                    <div id="workspace">
                        <router-view name="workspace"></router-view>
                    </div>
                    <div id="lower-bar">
                        <div class="lb-grid">
                            <router-view name="lowerBarLeft"></router-view>
                            <router-view name="lowerBarRight" :version="'pro'"></router-view>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Spinner v-show="isLoading"/>
    </div>
</template>

<script>
    import TheNavbar from "./Navbar/TheNavbar.vue"
    import TheModal from "./Modal/TheModal.vue";
    import TheStepsSidebar from "./StepsSidebar/TheStepsSidebar";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import Spinner from "./Spinner";
    import TheDebug from "./Debug/TheDebug";
    import {bus} from "../vue_bus";


    export default {
        name: "ConfiguratorMainLayout",
        components: {
            TheDebug,
            Spinner,
            TheStepsSidebar,
            TheModal,
            TheNavbar,
            vueCustomScrollbar
        },
        computed: {
            isLoading() {
                return !!this.$store.getters["IN_PROGRESS"];
            },
            debugWindow() {
                return this.$route.query.debug !== undefined;
            }
        },
        data() {
            return {
                // devicePixelRatio: 1,
                reloadingTimer: null
            }
        },
        created() {
            window.addEventListener("resize", this.devicePixelRatioReload);
            // this.devicePixelRatio = window.devicePixelRatio
        },
        mounted() {
            const projectUUID = this.$store.state.route.params.projectUUID;
            if(projectUUID) {
              this.$store.dispatch('projectList/CHECKING_PROJECT_WITH_SERVER', projectUUID);
            }
            this.$store.dispatch('saveProject/ENABLE_TIMER_SAVE_PROJECT');
        },
        destroyed() {
          this.$store.dispatch('saveProject/DISABLED_TIMER_SAVE_PROJECT');
            window.removeEventListener("resize", this.devicePixelRatioReload);
        },
        methods: {
            devicePixelRatioReload() {
                if (this.reloadingTimer) {
                    clearTimeout(this.reloadingTimer);
                    this.reloadingTimer = null;
                }
                // if (window.devicePixelRatio !== this.devicePixelRatio) {
                //     this.devicePixelRatio = window.devicePixelRatio;
                    this.reloadingTimer = setTimeout(() => {
                        window.location.reload();
                    }, 700);
                // }
            },
            // sendDataOnError() {
            //     bus.$emit("sendDataOnError");
            // }
        }
    }
</script>
